import { createAction, props } from '@ngrx/store';

export const LoadMenuByHandle = createAction('[Menu] Load Menu By Handle', props<{ handle: string }>());
export const LoadMenuByHandleSuccess = createAction('[Menu] Load Menu By Handle Success', props<{ menu: any }>());
export const LoadMenuByHandleFail = createAction('[Menu] Load Menu By Handle Fail', props<{ error: any }>());
